import React, { useContext, useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'
import { Typography, FormControl, FormHelperText, Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles';
import { MessageContext } from './Contexts'
import { format } from 'date-fns'
import { BillingDataRoomInfo } from 'modules/Rest'
import { LoadingDotsIcon } from './Icons'

const useStyles = makeStyles(theme => ({
  FormControl: {
    flex: 1,
    display: 'unset',
    textAlign: 'left',
    '& p': {textAlign: 'left'},
  },
  loadingDots: {
    paddingBottom: 10,
    paddingLeft: 10,
    display: 'inline-block',
  },
  renewalRow: {
    display: 'block',
  },
  renewalSection: {
    marginLeft: 0,
  }
}))

export default function DataRoomBillingCard() {
  const classes = useStyles()

  const { messageDispatch } = useContext(MessageContext)
  const { dataRoomKey } = useParams()
  const [loading, setLoading] = useState(false)
  const [billingInfo, setBillingInfo] = useState(null)

  const getBillingInfo = useCallback(async () => {
    setBillingInfo(null)
    if (dataRoomKey) {
      try {
        setLoading(true)
        const { data: { success, info, ...data } } = await BillingDataRoomInfo({ data_room: dataRoomKey })
        if (success) {
          setBillingInfo(data)
        } else {
          throw new Error(info ? info : 'An error occurred')
        }
      } catch (error) {
        messageDispatch({ type: 'warning', payload: error.message })
      }
      setLoading(false)
    }
  }, [messageDispatch, dataRoomKey])

  useEffect(() => {
    getBillingInfo()
  }, [getBillingInfo])

  return <>
    {billingInfo || loading ? <Box display="flex" flexDirection="row">
      <FormControl className={classes.FormControl}>
        <Typography variant="subtitle1">
          Billing information
        </Typography>
        {loading ? <div className={classes.loadingDots}><LoadingDotsIcon size={6} vPadding={6} hPadding={6}/></div> : null}
        {billingInfo && <FormHelperText className={classes.renewalSection}>
          {billingInfo.renewals.map((renewal_i, index) => <span key={index} className={classes.renewalRow}>
            {renewal_i.time && format(new Date(renewal_i.time), 'yyyy-MM-dd')}&nbsp;&nbsp;{renewal_i.type}
          </span>)}
          <span className={classes.renewalRow}>
            {billingInfo.next_renewal_time && format(new Date(billingInfo.next_renewal_time), 'yyyy-MM-dd')}&nbsp;&nbsp;Next renewal
          </span>
        </FormHelperText>}
      </FormControl>
    </Box> : null}
  </>
}
